let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jfxD9")).then(() => parcelRequire('e0SCK'));